module.exports = __webpack_public_path__ + "fonts/e57324a.woff2";